import moment from 'moment-timezone'

export default {
    filters: {
        formatEUR(amount, symbolBefore) {
            let eur = (Math.floor(parseFloat(amount) * 100) / 100).toFixed(2).split(/(?=(?:\d{3})+(?:\.|$))/g).join(",");
            if (symbolBefore) return '€ ' + eur;
            return eur + ' €';
        },
        formatEURWithoutSymbol(amount) {
            return (Math.floor(parseFloat(amount) * 100) / 100).toFixed(2);
        },
        formatUsdTether(amount) {
            return (Math.floor(parseFloat(amount) * 100) / 100).toFixed(2);
        },
        formatEurTether(amount) {
            return (Math.floor(parseFloat(amount) * 100) / 100).toFixed(2);
        },
        formatBTC(amount) {
            return (Math.floor(parseFloat(amount) * 10000) / 10000).toFixed(4);
        },
        formatETH(amount) {
            return (Math.floor(parseFloat(amount) * 10000) / 10000).toFixed(4);
        },
        formatDate(date, format = 'DD/MM/YYYY') {
            return moment(date).format(format)
        },
        formatSeparateComma(amount) {
            return amount.toString().replace('.',',');
        }
    },
    methods: {
        replaceDotCommaAmount(amount) {
            return this.$options.filters.formatSeparateComma(amount)
        },
        roundEUR(amount, symbolBefore) {
            return this.$options.filters.formatEUR(amount, symbolBefore);
        },
        roundEURWithoutSymbol(amount) {
            return this.$options.filters.formatEURWithoutSymbol(amount);
        },
        roundUsdTether(amount) {
            return this.$options.filters.formatUsdTether(amount);
        },
        roundEurTether(amount) {
            return this.$options.filters.formatEurTether(amount);
        },
        roundBTC(amount) {
            return this.$options.filters.formatBTC(amount);
        },
        roundETH(amount) {
            return this.$options.filters.formatETH(amount);
        },
        roundCurrency(currency, val) {
            let round;
            switch (currency) {
                case 'USD':
                case 'USDT': round = this.roundUsdTether; break;
                case 'EUR':
                case 'EURT': round = this.roundEurTether; break;
                case 'BTC': round = this.roundBTC; break;
                case 'ETH': round = this.roundETH; break;
                default: return 0;
            }
            return round(val);
        },
        formatDate(date, format = 'DD/MM/YYYY'){
            return this.$options.filters.formatDate(date, format);
        },
        formatNextDate(date, format = 'DD/MM/YYYY'){
          return this.$options.filters.formatDate(moment(date).add(1, 'days'), format);
      },
        formatFloatNumberWithComma (val, currency = 'EUR', editing = false) {
          if (editing) {
            return val;
          }
          if (val === null) {
            return `0,00`;
          }
          let str = val.toString();
          let result = str.replace(/\./i, ',');
          result = (result.indexOf(',') === -1) ? `${result},00` : result;
          let currencySymbol = '';
          switch (currency) {
            case "EUR":
              currencySymbol = '€';
              break;
            case 'USD':
              currencySymbol = '$';
              break;
            default:
              currencySymbol = '€';
          }
          return `${result} ${currencySymbol}`;
        },

        parseDate(created_at) {
          return created_at;
        },
        formatDocStatus(status) {
            switch (status) {
              case 'approved':
                return 'approuvé';
              case 'submitted':
                return 'soumis';
              case 'declined':
                return 'refusé';
              case 'pending':
                return 'en attente';
              default:
                return status;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/formats.js